import { jsx as _jsx } from "react/jsx-runtime";
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { useMultiStyleConfig } from '@companydotcom/potion';
import { FontAwesomeIcon } from '../font-awesome-icon';
export const CircleExclamationIcon = (props) => {
    const styles = useMultiStyleConfig('Icons', props);
    return _jsx(FontAwesomeIcon, { icon: faCircleExclamation, sx: styles.circleExclamation }, void 0);
};
